import { graphql } from 'gql'

export const GET_WORKSPACE_GENERAL_CONFIGURATION = graphql(`
  query getWorkspaceGeneralConfiguration($workspaceId: ID!) {
    workspaceGeneralConfiguration(workspaceId: $workspaceId) {
      ...WorkspaceGeneralConfigurationFragment
    }
  }
`)
